import { withInstall } from '@pc-fx-framework/utils/with-install'
import VPanel from './src/index.vue'

export const FxVPanel = withInstall(VPanel)
export default FxVPanel
